/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PowSolution } from './PowSolution';
const CreatePendingRegistrationCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['email', codecString],
    ['pow', PowSolution],
    [
        'privacyPolicyAccepted',
        /* #__PURE__ */ parsers.exactly(true),
        'privacy_policy_accepted',
    ],
]);
export class CreatePendingRegistrationCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreatePendingRegistrationCourseDataParser.decode(input).map(res => new CreatePendingRegistrationCourseData(res));
    }
    static unsafeDecode(input) {
        return CreatePendingRegistrationCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreatePendingRegistrationCourseDataParser.encode(data);
    }
    static schema() {
        return CreatePendingRegistrationCourseDataParser.schema();
    }
}
